import { Navigate, useSearchParams } from "react-router-dom";

const OLD = { guests: "members", people: "members", users: "members", storage: "storage" };

// The old Admin page now lives in Settings tabs
export default function AdminPage() {
  const [params] = useSearchParams();
  return <Navigate to={`/settings?tab=${OLD[params.get("tab")] || "members"}`} replace />;
}
